<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout wrap>
      <v-flex
        xs10
        body-1
      >
        <p>
          Aqua J Mutual Water Company is a small local company that is dedicated to providing the best water to our neighborhood. All of our Board Members and employees live within the neighborhood and volunteer their time to the water company. We currently do not have an office or full-time customer service as our employees work part time from their homes. Aqua J Mutual apologizes for any inconvenience this may cause but we promise to resolve any problems that occur in a timely manner and answer any questions that you may have.
        </p>
        <p>
          Aqua J Mutual Water Company holds board meetings frequently throughout the year and always hosted locally within the neighborhood. Everyone is always welcome to attend these meetings and bring any questions or concerns to the board. The Board also hosts a yearly Landowners BBQ and Meeting every summer. At that time any Landowner can become a Board Member. The dates of every meeting are included on your monthly invoice.
        </p>
        <h3>Contact</h3>

        <p>
          Business hours for the phone: 10am - 3pm. Please leave a detailed message.
        </p>

        <v-list two-line>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="indigo">phone</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>{{ this.phone }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider inset></v-divider>

          <v-list-tile :href="`mailto:${this.email}`">
            <v-list-tile-action>
              <v-icon color="indigo">mail</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>{{ this.email }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      phone: '(661) 750-7525',
      email: 'aquajmutual@gmail.com'
    }
  },
  methods: {
  }
}
</script>

<style>
  p b {
    font-size: 14px;
  }
</style>
